// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"359":"738ef253","1303":"738ef253","6559":"738ef253","6701":"738ef253","6937":"4e826d3a","7317":"738ef253","8442":"a19e01f8","9990":"738ef253"}[chunkId] + ".chunk.css";
};